import { TRootState } from "../@types"

export const selectproductWarehousesRefreshTable =  ( state: TRootState ) =>state.workOffersCategories.refreshTableWorkOffersCategories